import { AcceptanceStatus } from '@dealstack/shared/lib/generated';
import { KycApprovalStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import {
	KYCDocumentStatus,
	REQUESTED_STATUS,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/components/utils';

export const toDocumentStatus = (status: KycApprovalStatus): KYCDocumentStatus => {
	switch (status) {
		case AcceptanceStatus.APPROVED:
			return AcceptanceStatus.APPROVED;
		case AcceptanceStatus.REJECTED:
			return AcceptanceStatus.REJECTED;
		case AcceptanceStatus.REREQUESTED:
			return AcceptanceStatus.REREQUESTED;
		case AcceptanceStatus.PENDING:
			return AcceptanceStatus.PENDING;
		default:
			return REQUESTED_STATUS;
	}
};
